// src/components/Common/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const PrivateRoute = ({ children, role }) => {
  const { user, userRole, loading, roleError, signOut, retryRole } = useAuth();

  // Still loading auth or role
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  // Role fetch failed — show retry/sign-out option
  if (roleError) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        gap: '16px'
      }}>
        <h2>Unable to load your profile</h2>
        <p style={{ color: '#666' }}>{roleError}</p>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            onClick={retryRole}
            style={{
              padding: '10px 24px',
              background: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            Retry
          </button>
          <button
            onClick={async () => {
              await signOut();
              window.location.href = '/login';
            }}
            style={{
              padding: '10px 24px',
              background: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            Sign Out
          </button>
        </div>
      </div>
    );
  }

  // No user — redirect to login
  if (!user) {
    return <Navigate to="/login" />;
  }

  // Role loaded — check access
  if (role && userRole !== role) {
    switch (userRole) {
      case 'agent':
        return <Navigate to="/agent" />;
      case 'doctor':
        return <Navigate to="/doctor" />;
      case 'supervisor':
        return <Navigate to="/supervisor" />;
      case 'admin':
        return <Navigate to="/admin" />;
      case 'chew':
        return <Navigate to="/chew" />;
      default:
        return <Navigate to="/login" />;
    }
  }

  return children;
};

export default PrivateRoute;